/**
 * 迁移的js
 *
 */

import { presetRoutes } from '@/router'
import { useAppType } from '@/hooks/useAppType.js'
import { useCurrentUser } from '@/hooks/user'
import { dayjs } from 'element-plus'

const userHook = useCurrentUser()

const { appName, currentConfigEnvObj } = useAppType()

const isTestEnv = import.meta.env.VITE_NODE_ENV.includes('test')

export function getAppInfo() {
  return {
    name: appName.value + (isTestEnv ? '-测试' : ''),
    key: currentConfigEnvObj.value.serviceMainKey
  }
}

export function getRequestBaseUrl() {
  const baseUrl = import.meta.env.VITE_API_URL
  return baseUrl
}

export function getUserInfo() {
  let data = null
  const str = sessionStorage.getItem('userInfo') ?? localStorage.getItem('userInfo')
  try {
    data = JSON.parse(str)
  } catch (err) {}
  return data || {}
}

// 获取缓存的授权token
export function getAuthToken() {
  return userHook.info?.token ?? ''
}

// 前往授权登录页面
export function goToAuthLoginPage() {
  // if (window.location.hostname !== "localhost") {
  //   window.location.href = "http://open.duanju.com/admind/login.html";
  // }
  if (import.meta.env.VITE_NODE_ENV === 'test') {
    window.location.href = window.location.origin + import.meta.env.VITE_AUTH_LOGIN_URL
  }
}

// constants.js  树形结构扁平化
export function flattenTree(tree) {
  return tree.reduce((result, node) => {
    result.push(node)
    if (node.children) {
      result.push(...flattenTree(node.children))
    }
    return result
  }, [])
}

// 添加动态路由
export function addDynamicRoutes(router, routes) {
  routes.forEach(route => {
    router.addRoute(route)
  })
}

// 移除动态路由
export function removeDynamicRoutes(router) {
  const routes = router.getRoutes()
  const staticRoutePaths = presetRoutes.map(item => item.path)
  const removeRoutes = routes.filter(route => !staticRoutePaths.includes(route.path))
  removeRoutes.forEach(route => {
    router.removeRoute(route.name)
  })
}

// 获取动态路由
export function getDynamicRoutes(menu, routes) {
  const result = []
  menu.forEach(item => {
    const data = formatDynamicRoutes(item, routes)
    data.component && result.push(data)
  })

  return result
}

// 整理动态路由数据
function formatDynamicRoutes(data, routes) {
  let result = {}
  // type 1 菜单 2 路由
  const { path, type: node_type, children } = data

  switch (node_type) {
    case 1: // 路由和菜单
      if (routes) {
        const allowRoutes = routes.find(item => item.path === path)
        if (!!allowRoutes) {
          const { path, component, name, meta = {} } = allowRoutes
          result = {
            path,
            component,
            name,
            meta
          }
          if (children && children.length) {
            result.children = []
            children.forEach(item => {
              result.children.push(formatDynamicRoutes(item, allowRoutes.children))
            })
          }
        }
      }
      break
    case 2: // 功能和按钮
      result = {
        path
      }
      break
    default:
      break
  }
  return result
}

// 获取路由的路径
export function getRoutePaths(routes) {
  let result = []
  routes.forEach(item => {
    result = [...result, ...formatRoutePaths(item)]
  })
  return result
}

// 整理路由的路径
function formatRoutePaths(data) {
  let result = []
  const { component, path, children } = data
  if (component) {
    result = [path]
    if (children && children.length) {
      children.forEach(item => {
        formatRoutePaths(item).forEach(sub => {
          result = [...result, path + sub]
        })
      })
    }
  }
  return result
}

export function jumpPageAfterLogin(router, routes) {
  let authPaths = sessionStorage.getItem('auth-paths') ?? localStorage.getItem('auth-paths')
  authPaths = authPaths.split(',')
  const currentPage = localStorage.getItem('current-page')
  const query = localStorage.getItem('current-page-query')
  if (currentPage && authPaths.includes(currentPage) && currentPage !== '/login') {
    // 跳转之前访问的页面
    router.replace({
      path: currentPage,
      query: JSON.parse(query)
    })
  } else {
    if (routes[0]) {
      const firstPath = getRoutePath(routes[0])
      router.replace(firstPath)
    }
  }
}

// 获取单个路由的路径
export function getRoutePath(data) {
  let result = ''
  const { component, path, children } = data
  if (component) {
    result += path.includes('/') ? path : '/' + path
    if (children && children.length) {
      result += getRoutePath(children[0])
    }
  }
  return result
}

/**
 * @description 过滤菜单
 * @param {array} arr 树形结构数组
 * @param {array} roles 有权限&需要显示的导航
 */
export function getCurrentMenuList(arr, roles) {
  return arr
    .filter(x => {
      return roles.includes(x.path) && !x.meta.isHiden
    })
    .map(x => {
      return {
        ...x,
        children: x.children && getCurrentMenuList(x.children, roles)
      }
    })
}

// 获取页面的权限
export function getPageAuth() {
  const result = {}
  userHook.buttonPermissions.value?.forEach(path => {
    result[path] = true
  })
  return result
}

export function clearStorage() {
  localStorage.clear()
  sessionStorage.clear()
}

export const dateFormat = (date, fmt = 'yyyy-MM-dd HH:mm:ss') => {
  if (!date) return ''
  if (typeof date === 'string') {
    const time1 = date.replace(/-/g, '/')
    date = new Date(time1)
  } else {
    date = new Date(date)
  }
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 小时
    'H+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds() // 毫秒
  }
  var week = {
    0: '/u65e5',
    1: '/u4e00',
    2: '/u4e8c',
    3: '/u4e09',
    4: '/u56db',
    5: '/u4e94',
    6: '/u516d'
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (RegExp.$1.length > 1 ? (RegExp.$1.length > 2 ? '/u661f/u671f' : '/u5468') : '') + week[date.getDay() + '']
    )
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
  }
  return fmt
}

export function resetReactiveData(reactiveData, initData) {
  Object.assign(reactiveData, initData)
}

export function exportFile(res, filename, cb) {
  try {
    const data = res
    const blob = new Blob(['\ufeff' + data], { type: 'text/csv,charset=UTF-8' })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.download = `${filename}.csv`
    link.click()
    window.URL.revokeObjectURL(url)
    cb && cb()
  } catch (e) {
    console.log(e)
  }
}

export function exportFileXLSX(data, filename) {
  const blob = new Blob([data])
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.download = `${filename}.xlsx`
  link.click()
  window.URL.revokeObjectURL(url)
}

export function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]'
}

/**
 * 自动更新 需求来自投放改造 投放人员使用老版本添加了N条数据
 */
let lastSrcs

const scriptReg = /\<script.*src=["'](?<src>[^"']+)/gm

/**
 * 获取最新脚本链接
 * @returns []
 */
async function extractNewScripts() {
  const html = await fetch('/?_timestamp=' + Date.now()).then(res => res.text())
  scriptReg.lastIndex = 0
  const result = []
  let match = ''
  match = scriptReg.exec(html)
  result.push(match.groups.src)
  return result
}

async function needUpdate() {
  const newScripts = await extractNewScripts()
  if (!lastSrcs) {
    lastSrcs = newScripts
    return false
  }
  let result = false
  if (lastSrcs.length !== newScripts.length) {
    return true
  }
  for (let i = 0; i < lastSrcs.length; i++) {
    if (lastSrcs[i] !== newScripts[i]) {
      result = true
      break
    }
  }
  lastSrcs = newScripts
  return result
}

export async function isShowMeg() {
  const willUpdate = await needUpdate()
  if (willUpdate) {
    ElMessageBox.confirm(`页面有更新，点击确定刷新页面🚀`, '', {
      type: 'warning'
    })
      .then(() => {
        location.reload()
      })
      .catch(() => {})
  }
}

export function autoRefresh() {
  document.addEventListener('visibilitychange', () => {
    //浏览器tab标签切换事件
    if (document.visibilityState == 'visible') {
      //页面切换或者最小化
      isShowMeg()
    }
  })
}

export function jsonParse(target, defaultValue = {}) {
  let result = defaultValue
  if (isType(target, 'string')) {
    try {
      result = JSON.parse(target)
    } catch (error) {
      console.warn('JSON格式化对象错误 >>', error)
    }
  }
  return result
}

export function modifyData(target, value) {
  for (const key in value) {
    if (Object.prototype.hasOwnProperty.call(target, key)) {
      const item = value[key]
      const _target = target[key]
      // 深层逐个赋值
      if (isType(_target, 'object')) {
        modifyData(_target, item)
      } else {
        target[key] = item
      }
    }
  }
}

export function checkType(target) {
  const value = Object.prototype.toString.call(target)
  const result = value.match(/\[object (\S*)\]/)[1]
  return result.toLocaleLowerCase()
}
export function isType(target, type) {
  return checkType(target) === type
}

// 时间戳秒转字符串
export function formatterDate(date = '', fmt = 'YYYY-MM-DD HH:mm:ss') {
  return date ? dayjs(date * 1000).format(fmt) : ''
}

// 日期转时间戳秒
export function dateToTimestamp(date = '') {
  return date ? dayjs(date).unix() : ''
}

// UTC时间转字符串时间
export function UTCTimeFormatter(date, fmt = 'YYYY-MM-DD HH:mm:ss') {
  const d = new Date(date)
  return dayjs(d).format(fmt)
}

export const tableTimeFormatter = (row, column, cellValue) => {
  return cellValue ? UTCTimeFormatter(cellValue) : '--'
}

export const regPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{8,20}$/

export function enumValue(enumObj, target) {
  return enumObj[target] || ''
}

export function submitFormDataVoidStrTransInt(params, needTransArr) {
  if (Array.isArray(needTransArr)) {
    const param = { ...params }
    needTransArr.forEach(v => {
      if (param[v] === '' || param[v] === undefined) {
        param[v] = 0
      }
    })
    return param
  } else {
    return params
  }
}
